import { createProvider } from '@nvision/services/data-provider';

import * as advancedApi from './advanced/api';
import * as basicApi from './basic/api';
import { normalizeClaimsList } from './normalize';

export const fetchClaimsListBasic = createProvider(basicApi.fetchClaimsListBasic)
  .andThen((res) => normalizeClaimsList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch claims list aborted');
    } else {
      console.error('Fetch claims list was failed:', error);
    }
    throw error;
  });

export const fetchClaimsListAdvanced = createProvider(advancedApi.fetchClaimsListAdvanced)
  .andThen((res) => normalizeClaimsList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch claims list aborted');
    } else {
      console.error('Fetch claims list was failed:', error);
    }
    throw error;
  });
